import { isEmptyObject } from "../../../utils/tests";
import { MatchReportsQuery } from '../types';

/**
 * typeguard for MatchReportsQuery
 * @param MatchReportsQuery object passed to transformer
 */
export const isValidMatchReportsHome = (obj: MatchReportsQuery): boolean => Boolean(obj?.data?.getCompetitionReports && !isEmptyObject(obj.data.getCompetitionReports));
